import { useEffect, useState, useSyncExternalStore } from 'react';
import { isFetching, subscribeLoading } from '../api/client';

/** Thin indeterminate bar under the top bar while a page's data loads. Stays up at least 400ms so quick loads still register. */
export function LoadingBar() {
  const busy = useSyncExternalStore(subscribeLoading, isFetching);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (busy) { setShow(true); return; }
    const t = setTimeout(() => setShow(false), 400);
    return () => clearTimeout(t);
  }, [busy]);

  return show ? <div className="lbar" role="progressbar" aria-label="Loading" aria-busy="true"><span /></div> : null;
}
